import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';
import variant from '@styled-system/variant';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('Superscript')(css({
    cursor: 'pointer',
}), variant({
    prop: 'variant',
    variants: {
        default: {},
        underline: {
            textDecorationLine: 'underline',
            textDecorationStyle: 'solid',
            textDecorationSkipInk: 'none',
            textDecorationThickness: 'auto',
            textUnderlineOffset: 'auto',
            textUnderlinePosition: 'from-font',
        },
    },
}));
export default themeStyles;
